export default "/048cb1f2b29308e18768c65cfd51e426596a830c/ac478f259eebce517c6cc06e4306b00d.svg";